import { WixThemeVariableNames } from '@wix/wix-site-theme-variables';
import { ThemeVariables } from './types';

const CSS_VARIABLE_REGEX = /var\((?:[^()]+|\((?:[^()]+|\([^()]*\))*\))*\)/g;

export const isCssVariable = (value: string) => CSS_VARIABLE_REGEX.test(value);

export const applyThemeVariables = (
  cssValue: string,
  themeVariables: ThemeVariables,
) => {
  const extractVariableName = (value: string) => {
    return value.match(/var\(--\s*([^,\s)]+)/)?.[1];
  };

  const getThemeToken = (variableName: string) => {
    return themeVariables[variableName] && variableName in WixThemeVariableNames
      ? themeVariables[variableName]
      : undefined;
  };

  return cssValue.replace(CSS_VARIABLE_REGEX, (match) => {
    const variableName = extractVariableName(match);
    if (typeof variableName !== 'undefined') {
      const themeToken = getThemeToken(variableName);
      return themeToken ? themeToken : match;
    }

    return match;
  });
};
